<template>
    <div>
        <base-crud
                crudName="Material Promocional"
                newText="Novo Material Promocional"
                :table="promotionalTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="true"
                :enableSetStatus="true"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                promotionalTable: 'promotionalTable',
                materials: [],
                pages: [],
                url: '',
                columns: ['id', 'name', 'cover_photo', 'status', 'actions'],
                tableData: ['id', 'name', 'cover_photo', 'status'],
                options: {
                    sortable: ['id', 'name'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll'},
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    templates: {
                        type: function (h, row, index) {
                            return row.type.name
                        },
                        status: function (h, row, index) {
                            return row.status === 2 ? 'Inativo' : 'Ativo'
                        }
                    },
                    headings: {
                        'name': 'Nome',
                        'cover_photo': 'Capa',
                        'actions': 'Ações'
                    }
                },
                endPoint: 'promotional/'
            }
        },
        components: {
            BaseCrud
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Promotional/Crud.vue